export default {
	leadsQueryString : (state) => {
		const data = {
			page         : state.page,
			leadsPerPage : state.perPage,
			searchLead   : state.search,
			dateStart    : state.filters.dateRangeStart,
			dateEnd      : state.filters.dateRangeEnd,
			sites        : state.filters.sites,
			campaigns    : state.filters.campaigns,
			tags         : state.filters.tags,
		}

		let str = '?' + Object.keys(data).reduce((array, key) => {
			if (data[key]) {
				if (Array.isArray(data[key])) {
					data[key].forEach(item => array.push(key + '[]=' + item))
				} else {
					array.push(key + '=' + encodeURIComponent(data[key]))
				}
			}
			return array
		}, []).join('&')
		return str
	},
	exportQueryString : (state, getters) => {
		const exportString = getters.leadsQueryString
		let str = exportString + '&' + Object.keys(state.export).reduce((array, key) => {
			array.push(`export[${key}]=` + encodeURIComponent(state.export[key]))
			return array
		}, []).join('&')

		return str
	},

	getCampaignFilterOptions : (state) => {
		return state.filterOptions.campaigns.map((campaign) => {
			return {
				name  : campaign.name,
				value : campaign.id,
			}
		})
	},
	getSiteFilterOptions : (state) => {
		return state.filterOptions.sites.map((site) => {
			return {
				name  : site.name,
				value : site.numericId,
			}
		})
	},
	getTagFilterOptions : (state) => {
		return state.filterOptions.tags.map((tag) => {
			return {
				name  : tag.name,
				value : tag.id,
			}
		})
	},
}
